<template>
  <VFiltersPopup
      popup-class="outer-filter-popup tender-outer-filter"
      :title-list="titleList"
      @submit="applyFilter"
      @clear="clearFilter"
  >
    <section class="outer-filter-container">
      <VButtonGroup class="mds-btn-group mds-form-control">
        <VButton
            :theme="draft.isMine ? 'primary' : 'default'"
            @click="draft.isMine = true"
        >
          <template #icon>
            <VIcon material="person_black" />
          </template>
          Мои тендеры
        </VButton>
        <VButton
            :theme="draft.isMine ? 'default' : 'primary'"
            @click="draft.isMine = false"
        >
          <template #icon>
            <VIcon material="filter_alt" />
          </template>
          Все тендеры
        </VButton>
      </VButtonGroup>

      <VSelectV2
          v-model="draft.responsible"
          placeholder="Ответственный"
          :disabled="draft.isMine"
          :data="({pattern}) => PersonsService.searchPersons(pattern, currentPartnerId)"
      />

      <VSelectV2
          v-if="isBuyer"
          v-model="draft.seller"
          placeholder="Поставщик со ставкой"
          :data="({pattern}) => PartnersService.getList({pattern})"
      />

      <VSelectV2
          v-model="draft.buyer"
          :disabled="!isPrivilegedSWUsers && !isSeller"
          placeholder="Покупатель"
          :options-nested="$core.dictionaries.tenderBuyers.toArray()"
          :data="({pattern}) => PartnersService.getList({pattern, types: ['buyer']})"
      />

      <VDateRangeInput
          layout="vertical"
          placeholder="Интервал получения"
          clearable
          v-model="draft.desiredReceiptPeriod"
      />

      <VDateRangeInput
          layout="vertical"
          placeholder="Интервал завершения"
          clearable
          v-model="draft.endAtPeriod"
      />

      <VCheckboxGroup
          v-model="draft.isPreorderNeeded"
          label="Тип тендера"
          layout="vertical"
          type-radio
          checkbox-layout="horizontal"
          :options="$core.dictionaries.tenderIsPreorderNeeded.toArray()"
          option-label="name"
      />

      <VCheckboxGroup
          v-model="draft.winnersCategory"
          class="winners-categories"
          label="Категория тендера"
          layout="vertical"
          type-radio
          checkbox-layout="horizontal"
          :options="TendersService.WINNERS_CATEGORIES.toArray()"
          option-label="name"
      />
    </section>
  </VFiltersPopup>
</template>

<style lang="scss" src="./TendersFilter.scss"/>

<script lang="ts">

import VFiltersPopup      from '@/components/VFiltersPopup/VFiltersPopup';

import TendersPageFilter 	from '@/domains/Tenders/TendersPageFilter';
import PartnersService 		from '@/domains/Partners/PartnersService';
import PersonsService 		from '@/domains/Persons/PersonsService';
import Dictionaries 			from "@/core/services/Dictionaries/Dictionaries";
import TendersService from "@/domains/Tenders/TendersService";

export default defineComponent({
  name: 'TendersFilter',

  components: { VFiltersPopup },

  props: {
    tendersPageFilter: {
      type: Object as PropType<TendersPageFilter>,
      required: true,
    }
  },

  emits: [TendersPageFilter.Events.Updated],

  setup() {
    return {
      TendersService,
      PartnersService,
      PersonsService,
      Dictionaries,
    }
  },

  data() {
    return {
      // Draft - черновик для редактирования
      draft: this.$core.utils.cloneDeep(this.tendersPageFilter),
    };
  },

  computed: {
    isBuyer() {
      return this.$core.currentPartner.isBuyer;
    },

    isSeller() {
      return this.$core.currentPartner.isSeller;
    },

    currentPartnerId() {
      return this.$core.currentPartner.id;
    },

    isPrivilegedSWUsers() {
      return this.$core.currentUser.isPrivileged;
    },

    titleList(): string[] {
      const texts: string[] = [];

      if (this.tendersPageFilter.isMine) {
        texts.push('Мои тендеры');
      } else if (this.tendersPageFilter.responsible) {
        texts.push(this.tendersPageFilter.responsible.name);
      } else {
        texts.push('Все тендеры');
      }


      if (this.tendersPageFilter.seller?.name) {
        texts.push(this.tendersPageFilter.seller.name);
      }

      if (this.tendersPageFilter.buyer?.name) {
        texts.push(this.tendersPageFilter.buyer.name);
      }

      if (this.tendersPageFilter.desiredReceiptPeriod?.start && this.tendersPageFilter.desiredReceiptPeriod?.end) {
        texts.push(`Получение ${this.tendersPageFilter.desiredReceiptPeriod.getStringRepresentation()}`);
      }

      if (this.tendersPageFilter.endAtPeriod?.start && this.tendersPageFilter.endAtPeriod?.end) {
        texts.push(`Завершение ${this.tendersPageFilter.endAtPeriod.getStringRepresentation()}`);
      }

      if (this.tendersPageFilter.isPreorderNeeded?.id !== 3) {
        texts.push(this.tendersPageFilter.isPreorderNeeded.name);
      }

      if (this.tendersPageFilter.winnersCategory?.id !== 3) {
        texts.push(`Категория: ${this.tendersPageFilter.winnersCategory.name}`);
      }

      return texts;
    },
  },

  methods: {
    applyFilter() {
      // Эмитим draft родителю
      this.$emit(TendersPageFilter.Events.Updated, this.draft);
      this.draft.apply();
      // Создаём новый draft для следующего редактирования
      this.draft = this.$core.utils.cloneDeep(this.draft);
    },

    clearFilter() {
      // Сбрасываем tendersPageFilter
      this.tendersPageFilter.reset();

      // Создаём новый draft из сброшенного tendersPageFilter
      this.draft = this.$core.utils.cloneDeep(this.tendersPageFilter);

      // Эмитим родителю
      this.$emit(TendersPageFilter.Events.Updated, this.tendersPageFilter);
    },
  },
});
</script>
